"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _subscriptionsTransportWs = require("subscriptions-transport-ws");

var _getJWT = _interopRequireDefault(require("../auth/getJWT"));

var _getSession = _interopRequireDefault(require("../auth/getSession"));

var _getSignature = _interopRequireDefault(require("../auth/getSignature"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var getConnectionParams = function getConnectionParams() {
  var params = {};
  var session = (0, _getSession["default"])();
  var jwt = (0, _getJWT["default"])();

  if (jwt) {
    params = {
      jwt: jwt
    };
  } else if (session) {
    var publicKey = session.publicKey,
        secretKey = session.secretKey;

    if (publicKey && secretKey) {
      var nonce = new Date().getTime();
      var signature = (0, _getSignature["default"])(nonce + 'websockethandshake', session);
      params = {
        nonce: nonce,
        publicKey: publicKey,
        signature: signature
      };
    }
  }

  return params;
};

function _default(options) {
  var endpointURL = options.endpointURL,
      subscriptionsPath = options.subscriptionsPath;
  var uri = endpointURL.replace('http', 'ws') + subscriptionsPath;
  var client = new _subscriptionsTransportWs.SubscriptionClient(uri, _objectSpread({
    reconnect: true,
    lazy: true,
    reconnectionAttempts: 10,
    connectionParams: getConnectionParams
  }, options.wsOptions));
  options.wsClient = client;
  return client;
}